import FontFaceObserver from 'fontfaceobserver';

export default () => {
	const $html = document.getElementsByTagName('html')[0];
	const apfel = new FontFaceObserver('ApfelGrotezk');
	const saansMedium = new FontFaceObserver('Saans-Medium');
	const saansRegular = new FontFaceObserver('Saans-Regular');
	const saansSemiBold = new FontFaceObserver('Saans-SemiBold');

	Promise.all([
		apfel.load(),
		saansMedium.load(),
		saansRegular.load(),
		saansSemiBold.load(),
	])
		.then(() => $html.classList.add('fonts-loaded'))
		.catch(() => $html.classList.add('fonts-failed'));
};
